import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import { AddPaymentMethodIcon } from '../../../vectors/index';
import PaymentInformationForm from '@features/employerOnboarding/components/PaymentInformationForm/PaymentInformationForm';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { Plan } from '@features/employerOnboarding/components/PricingOptions/constants';
import { BillingCycle, PaymentPeriod, PlanType } from '@features/payments';

type AddPaymentMethodModalProps = {
  handleClose: () => void;
  handleSucess?: () => void;
  selectedPlanId?: string;
  addPaymentInformation?: boolean;
  currentPaymentInfo?: boolean;
  companyId?: number;
  paymentPeriod?: BillingCycle | PaymentPeriod;
  selectedPlan?: PlanType | Plan | null;
};

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_KEY);

const AddPaymentMethodModal: FC<AddPaymentMethodModalProps> = ({
  handleClose,
  handleSucess,
  selectedPlanId,
  paymentPeriod,
  selectedPlan,
  companyId,
  addPaymentInformation,
  currentPaymentInfo,
}) => {
  const [errorText, setErrorText] = useState<string>('');
  return (
    <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <AddPaymentMethodIcon />
        <br />
        <Typography variant="h4">Add Payment Method</Typography>
      </DialogTitle>
      <DialogContent>
        {errorText && (
          <Alert sx={{ margin: '10px 0' }} severity="error">
            {errorText}
          </Alert>
        )}
        <Elements stripe={stripePromise}>
          <PaymentInformationForm
            handleClose={handleClose}
            handleSucess={handleSucess}
            addPaymentInformation={addPaymentInformation ?? true}
            selectedPlanId={selectedPlanId}
            paymentPeriod={paymentPeriod}
            selectedPlan={selectedPlan}
            companyId={companyId}
            currentPaymentInfo={currentPaymentInfo}
          />
        </Elements>
      </DialogContent>
    </Dialog>
  );
};

export default AddPaymentMethodModal;
